import FeedCard from '@/components/cards/FeedCard';
import React from 'react';

export enum EntityCardMode {
  Default = 'default',
  Feed = 'feed'
}

export enum EntityCardType {
  Article = 'article',
  Course = 'course',
  EducationProvider = 'education_provider',
  Event = 'event',
  GraduateProfile = 'graduate_profile',
  Opportunity = 'opportunity',
  Organisation = 'organisation',
  Pathway = 'pathway',
  Video = 'video',
  Publication = 'publication'
}

/** @todo: all below should be removed once all cards have been updates */
export enum CardTypes {
  Article,
  Opportunity,
  Event,
  Video,
  Organisation,
  Course,
  EducationProvider,
  GraduateProfile,
  Publication,
  Custom,
  Sidebar,
  Feed,
  Pathway
}

export enum BookmarkType {
  Save,
  Follow
}

export type CardAttributes = {
  id?: string;
  type?: string;
  heading?: string;
  subHeading?: string;
  headline?: string;
  description?: string;
  footer?: string;
  cohortLabel?: string;
  cohort?: string;
  opportunityType?: string;

  disableRadius?: boolean;
  disableBackground?: boolean;
  disablePadding?: boolean;
  disableShadow?: boolean;
  disableHover?: boolean;
  disableBorder?: boolean;
  fullHeight?: boolean;
  active?: boolean;
  cornerOverlay?: any;

  suppressTracking?: boolean;
  iconOnlyActions?: boolean;
  inlineActions?: boolean;
  disableActions?: boolean;
  customClass?: string;

  disableImages?: boolean;
  suppressImages?: boolean;
};

export enum ImageTypes {
  gatsby = 'gatsby',
  img = 'img',
  html = 'html'
}

export type ImageType = {
  type: string;
  image: any;
  alt: string;
};

export type CardConfig = {
  excludes?: string[];
  images?: { [key: string]: { classes?: string; srcClasses?: string } };
  variant?: string;
  classNames?: { [key: string]: string };
};

export type CardInfo = {
  id: string;
  reference: string;
  index: string;
  path: string | null;
  component: React.FC;
  attributes: CardAttributes;
  onClick: Function | null;
  type?: string;
  images?: any;
  bookmarkType?: BookmarkType;
  body?: any;

  data: any;
  slots?: { [key: string]: any };
  config?: CardConfig;
};

export type CardInternalInfo = {
  id: string;
  drupal_id?: string;
  type: string;
  title: string;
  descriptionTitle?: string | React.ReactNode;
  description?: string;
  descriptionFooterTitle?: string;
  videoUrl?: string;
};

export const CardFlagType = {
  featured: { appearance: 'mint', label: 'Featured' },
  spotlight: { appearance: 'shock', label: 'Spotlight' },
  matched: { appearance: 'banana', label: 'Matched' }
};

export const CardVariants = {
  Feed: FeedCard
};
